module.exports = "/_next/static/images/1491752b48bdd26759fdf4f8b80a8753-gift-illustration@0.5x.png.webp";